import React, { useState } from "react";

const TOOL_OPTIONS = [
  { value: "none", label: "No tool calls" },
  { value: "web_search", label: "Web search" }
];

const REASONING_OPTIONS = [
  { value: "disable", label: "Reasoning disabled" },
  { value: "low", label: "Low effort" },
  { value: "medium", label: "Medium effort" },
  { value: "high", label: "High effort" }
];

function ChatComposer({
  onSend,
  disabled,
  model,
  availableModels,
  onModelChange,
  reasoningEffort,
  onReasoningEffortChange,
  toolChoice,
  onToolChoiceChange
}) {
  const [value, setValue] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!value.trim()) return;
    onSend?.({
      prompt: value.trim(),
      model,
      reasoningEffort,
      toolChoice
    });
    setValue("");
  };

  return (
    <form onSubmit={handleSubmit} className="grid" style={{ gap: "12px" }}>
      <div className="grid" style={{ gap: "8px", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))" }}>
        {availableModels && <label className="field">
          <span className="label">Model</span>
          <select
            className="input"
            value={model}
            onChange={(e) => onModelChange?.(e.target.value)}
            disabled={disabled}
          >
            {availableModels.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>}
        <label className="field">
          <span className="label">Tool calls</span>
          <select
            className="input"
            value={toolChoice}
            onChange={(e) => onToolChoiceChange?.(e.target.value)}
            disabled={disabled}
          >
            {TOOL_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
        <label className="field">
          <span className="label">Reasoning effort</span>
          <select
            className="input"
            value={reasoningEffort}
            onChange={(e) => onReasoningEffortChange?.(e.target.value)}
            disabled={disabled}
          >
            {REASONING_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      </div>

      <textarea
        className="textarea"
        placeholder="Describe your app, attach MCP or Swagger specs, or request UI/agent changes..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={disabled}
      />
      <div className="flex-between">
        <span className="muted">
          The agent will plan agents, build Firebase Functions, and design your canvas UI.
        </span>
        <button className="button" type="submit" disabled={disabled}>
          Send to agent
        </button>
      </div>
    </form>
  );
}

export default ChatComposer;
